/**
 * The clinics' day sheet, as the screen and the paper read it.
 *
 * The server builds the rows (Backend/lib/clinicRoster.js); this decides how
 * they read: the colour a specialty is drawn in, the start time in the
 * twelve-hour form the hall reads ("3:30 م"), and the word in the time column
 * when there is no session to start.
 *
 * Pure: no React.
 */

import { formatTime12 } from './dates';

/** The colours a specialty can take, in the order they are handed out. */
export const SHEET_TONES = Object.freeze(['cyan', 'violet', 'emerald', 'amber', 'rose', 'sky', 'teal', 'orange']);

/**
 * A stable colour for a piece of text: the same specialty is always the same
 * colour, on every day's sheet, without anybody choosing one.
 */
export function toneForText(text) {
  const value = String(text || '');
  if (!value) return 'slate';
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  return SHEET_TONES[hash % SHEET_TONES.length];
}

export const SHEET_STATUS = Object.freeze({
  scheduled: { label: 'في الموعد', icon: 'check-circle-2', tone: 'emerald' },
  excused: { label: 'معتذر', icon: 'user-x', tone: 'red' },
  closed: { label: 'مغلق', icon: 'calendar-x', tone: 'slate' },
});

/** What the time column says: the start time, or why there is none. */
export function sheetTimeLabel(row) {
  if (!row) return '';
  if (row.status === 'excused') return 'معتذر';
  if (row.status === 'closed') return 'مغلق';
  return row.startTime ? formatTime12(row.startTime) : '—';
}

/** Did the day's plan move the start from the clinic's usual time? */
export const startMoved = (row) => Boolean(row && row.startTime && row.usualStartTime && row.startTime !== row.usualStartTime);

/** The day before a "YYYY-MM-DD", for "same as yesterday". */
export function previousDay(dateKey) {
  const d = new Date(`${dateKey}T00:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  d.setDate(d.getDate() - 1);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
